import MessagesDisplay from "../../Messages/MessagesDisplay";

// use pageData context
import { usePageData } from '../../../contexts/PageData';

const Messages = () => {
  const { data = {} } = usePageData();
  return (
    <MessagesDisplay includeHeader={false} customer_id={data?.customer_id} />
  );
};

export default Messages;